<div *ngIf="header" class="header position-fixed w-100 bg-white">
  <!--WEB MENU-->

  <a href="#footer" class="skip-link">Skip to content</a>
  <!--First menu-->
  <ng-container>
  <div (click)="closeHeader()" class="d-flex flex-row w-100 h-50px col-12 hidden-phone">
    <div class="d-flex align-items-center flex-grow-1">
      <div class="col-3 text-center">
        <img loading="lazy" src="{{icon}}" alt="image-{{iconAlt}}" style="width: 32px; height: 32px;">
      </div>
      <div class="dropdown-container-selection-user col-12 h-100" ngbDropdown>
        <button class="btn col-9 w-100 button-selection-user d-flex ps-0 pb-0 h-50" ngbDropdownToggle
          (click)="contenutiPerClicked()">
          <div class="w-100 d-flex flex-column text-start">
            <p *ngIf="!isContenutiPerClicked" class="mb-0 fs-12 me-1 ">{{ "HEADER.SELECT_CONTENT_FOR" | translate }}<i
                class="fa fa-chevron-down ms-2" aria-hidden="true"></i></p>
            <p *ngIf="isContenutiPerClicked" class="mb-0 fs-12 me-1 ">{{ "HEADER.SELECT_CONTENT_FOR" | translate }}<i
                class="fa fa-chevron-up ms-2" aria-hidden="true"></i></p>
            <div>
              <span class="font-size-14px text-primary-g">
                {{contenutiPerType.length > 35 ? contenutiPerType.substring(0, 35) + '...' : contenutiPerType}}
              </span>
            </div>
          </div>
        </button>
        <div *ngIf="header && header.field_barra_terziaria" class="dropdown-item-container-selection-user p-0 col-12"
          ngbDropdownMenu>
          <button *ngFor="let item of header.field_barra_terziaria" class="item w-100 text-uppercase"
            ngbDropdownItem>
            <img loading="lazy" class="me-4" style="width: 28px;" src="{{env.urlApi}}{{item.field_icona_elemento_menu}}" alt="icon | Lumsa">
            <span *ngFor="let subItem of item.field_link_correlato"
              class="pe-5 py-3 ls-label-small-semibold text-brand-10"
              (click)="changeContenutiPer(item)">{{subItem.label}}
            </span>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="header && header.field_barra_secondaria"
      class="flex-grow-1 text-primary-g z-index-99 bg-brand-99">
      <ul (mouseover)="showSuperMenu($event)" (mouseleave)="leaveSuperMenu()"
        class="d-flex justify-content-evenly w-100 h-100 list-menu-first-level align-items-center text-center col-12 ps-0">
        <li *ngFor="let item of header.field_barra_secondaria; let i = index" [attr.data-index-li]="i"
          class="me-4 cursor-pointer w-100 p-3 text-uppercase" [ngClass]="{'bg-brand-95': indexColorHover === i}" [attr.role]="'listitem'" tabindex="0">
          <ng-container *ngFor="let subItem of item.field_titolo_elemento">
            <span class="">{{ subItem.value }}</span>
          </ng-container>
        </li>
      </ul>
      <ng-container>
        <div *ngIf="superMenu && header && header.field_barra_secondaria.length"
          class="container-super-menu z-index-99 row gx-0 bg-brand-95 p-3" (mouseleave)="hideSuperMenu()" >
          <div class="col-3 h-100 align-self-center border-grey__right">
            <div class="d-flex flex-column align-self-start p-5 mb-5">
              <h2 *ngIf="titoliElementi" class="ls-h2-section-title text-brand-10">
                {{titoliElementi}}
              </h2>
            </div>
            <div *ngFor="let item of socialsInTitle">
              <ng-container *ngIf="item.value === '1'" class="d-flex flex-column">
                <div class="d-flex list-style-none mb-0 w-100 px-5 py-4">
                  <div *ngFor="let social of nodeService.header.field_link_social" class="mb-0 me-2">
                    <div *ngFor="let item of social.field_nome_social" class="">
                      <a *ngFor="let linkSocial of social.field_link_social" class="" [href]="linkSocial.value" target="_blank" [attr.aria-label]="'icon social'">
                        <img class="widAndHei-24" loading="lazy" [src]="nodeService.hashMapSocialPngGreen[item.value]" alt="icon_language_{{item.value.toLowerCase()}}">
                      </a>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div *ngFor="let item of arrayLoop; let i = index" class="{{classColumnTabSuperMenu}} d-flex flex-column p-4">
            <div class="d-flex flex-column">
              <span *ngFor="let subItem of item.field_titolo_colonna"
                class=" text-neutral-40 ls-label-large-semibold mb-2">{{subItem.value}}</span>
              <span *ngFor="let subItem of item.field_descrizione_colonna" class="item-description text-neutral-40 mb-3" [innerHTML]="subItem.value"></span>
              <ng-container *ngFor="let subItem of item.field_link_colonna">
                <a *ngIf="!(subItem.url.startsWith('http'))" class="item-link ls-label-medium-semibold mb-3" 
                  [routerLink]="navigationService.splitUrlRouterLink(subItem.url).path" (click)="hideSuperMenu()"
                  [queryParams]="navigationService.splitUrlRouterLink(subItem.url).queryParams">
                  {{subItem.label}}
                </a>
                <a *ngIf="subItem.url.startsWith('http')" [href]="subItem.url" target="_blank" class="item-link ls-label-medium-semibold mb-3">{{subItem.label}}</a>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div ngbDropdown class="dropdown-flag d-flex flex-grow-1 justify-content-end bg-secondary-g text-primary-g align-items-center text-center dropdown-container">
      <button type="button" class="btn ms-0 me-3 align-items-center h-100 pe-4" style="border-right: 1px solid #CCD1CF;"
        id="dropdownBasic1" ngbDropdownToggle>
        <div>
          <img loading="lazy" src="./assets/images/input.png" alt="image_input" class="me-2" style="width: 19px; height: 16px;">
          <span class="font-size-12px text-brand-40">{{loginType | translate | uppercase}}<i
              class="fa fa-chevron-down ms-2" aria-hidden="true"></i></span>
        </div>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-item-container p-0" style="width: 127px;">
        <button ngbDropdownItem class="item me-1 text-uppercase"><img loading="lazy" src="./assets/images/input.png" class="me-1" alt="icon | Lumsa"> {{
          "AUTH.LOGIN_TITLE" | translate }} <i class="fa fa-chevron-up ms-2" aria-hidden="true"></i></button>
        <button ngbDropdownItem class="item me-1" (click)="changeLogin('mialumsa')"><img loading="lazy"
            src="./assets/images/alternate_email.png" alt="icon | Lumsa" class="me-1">MI@LUMSA</button>
          <button ngbDropdownItem class="item me-1" (click)="changeLogin('lumsa')"><img loading="lazy"
              src="./assets/images/language-grey.png" alt="icon | Lumsa" class="me-1">LUMSA.IT</button>
        <button ngbDropdownItem class="item me-1" (click)="changeLogin('intranet')"><img loading="lazy" src="./assets/images/lan.png"
            class="me-1" alt="icon | Lumsa">INTRANET</button>
      </div>
      <!-- DROPDOWN LINGUA -->
      <div class="h-100 pe-2" style="border-right: 1px solid #CCD1CF;">
        <div ngbDropdown class="d-inline-block dropdown-container h-100">
          <button type="button" class="btn font-size-12px h-100" id="dropdownLanguage" ngbDropdownToggle role="button">
            <!-- <span>{{ imageLanguages.text }}</span> -->
            <div *ngIf="currentLang && imageLanguages">
              <!-- <img loading="lazy" [src]="imageLanguages.url" class="me-1 widAndHei-24" alt="icon | Lumsa"> -->
              {{ imageLanguages.text }}<i class="fa fa-chevron-down ms-1" aria-hidden="true"></i>
            </div>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownLanguage" class="dropdown-item-container dropdownLanguage p-0">
              <button ngbDropdownItem class="item me-1 d-flex justify-content-center align-items-center">
                <!-- <img loading="lazy" src="{{imageLanguages.url}}" alt="icon_language_{{imageLanguages.codeApi}} | Lumsa" class="me-1 widAndHei-24"> -->
                {{imageLanguages.text}}
                <i  class="fa fa-chevron-up ms-2" aria-hidden="true"></i>
              </button>

            <ng-container *ngFor="let lang of languagesList; index as i">
              <button *ngIf="lang.text != imageLanguages.text && (!lang.showOnlyInNodeType || lang.showOnlyInNodeType === helpersService.nodeType)" ngbDropdownItem (click)="changeLang(lang.code)" class="item me-1 d-flex justify-content-center align-items-center">
                <!-- <img loading="lazy" src="{{lang.url}}" alt="icon_language_{{lang.codeApi}} | Lumsa" class="me-1 widAndHei-24"> -->
                {{lang.text}}
              </button>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- END DROPDOWN LINGUA -->
      <div class="mx-4 cursor-pointer" (click)="showSearchB()" role="button" tabindex="0">
        <img loading="lazy" src="./assets/images/search_green.svg" alt="icon_search | Lumsa" style="width: 32px; height: 32px;">
      </div>
    </div>
    <div *ngIf="showSearchBar" [ngClass]="showSearch ? 'moveSearch' : ''" class="search-container w-100 "
      (click)="closeSearchBar($event)">
      <form class="form-inline">
        <div class="d-flex shadow h-50px">
          <div class="w-100 h-100 input-search-global">
            <input [formControl]="searchGlobal" [ngModelOptions]="{standalone: true}" type="search" placeholder="{{ 'HEADER.WHAT_LOOKING' | translate }}" 
            [attr.aria-label]="'Search'" tabindex="1"
              class="w-100 h-100 border-0 p-3">
            <div *ngIf="waitSuggestions" class="input-search-global__container-suggestions">
              <ul>
                <div>
                  <span class="mb-3 ls-p-semibold">
                    <span>{{"BLOCK.SPINNER.LOADING" | translate}}</span>
                    <i class="fas fa-spin fa-circle-notch ms-3 ml-2"></i>
                  </span>
                </div>
              </ul>
            </div>
            <div *ngIf="!waitSuggestions && suggestions && suggestions.length" class="input-search-global__container-suggestions">
              <ul>
                <li *ngFor="let suggestion of suggestions">
                  <a class="ls-p" [routerLink]="navigationService.splitUrlRouterLink(suggestion.link).path" [queryParams]="navigationService.splitUrlRouterLink(suggestion.link).queryParams" [innerHTML]="suggestion.title" (click)="closeInputSearch()"></a>
                </li>
                <div>
                  <p class="mb-0 ls-p-semibold" (click)="searchWithFilter()">{{ 'HEADER.SEARCH_ALL' | translate }}</p>
                </div>
              </ul>
            </div>
          </div>
          <div ngbDropdown class="d-inline-block dropdown-container-search">
            <button type="button" class="h-50px text-uppercase ls-label-small-semibold text-brand-10 px-4" ngbDropdownToggle id="dropdownContent">
              <span>{{ typeSearch | translate }}</span>
              <i class="fa fa-chevron-down ms-3" aria-hidden="true"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownContent" class="dropdown-item-container p-0 w-100">
              <button ngbDropdownItem class="item me-1 p-3 border-bottom ls-label-small-semibold text-brand-10 text-uppercase"
                (click)="changeTypeSearch('search')">
                <img loading="lazy" src="./assets/images/language.png" alt="icon_search_all | Lumsa" class="me-1">
                {{ 'HEADER.DROPDOWN_SEARCH.ALL' | translate }}
              </button>
              <button ngbDropdownItem class="item me-1 p-3 border-bottom ls-label-small-semibold text-brand-10 text-uppercase"
                (click)="changeTypeSearch('faqs')">
                <img loading="lazy" src="./assets/images/help.png" alt="icon_search_faq | Lumsa" class="me-1">
                {{ 'HEADER.DROPDOWN_SEARCH.FAQ' | translate }}
              </button>
            </div>
          </div>
          <div (click)="searchWithFilter()" class="px-4 py-2 cursor-pointer h-100 search-container-second">
            <img loading="lazy" src="./assets/images/search_white.svg" alt="icon search light">
          </div>
        </div>
      </form>
    </div>

  </div>
  <!--Second menu-->
  <div class="header__web-menu hidden-phone m-auto">
    <div class="header__web-menu__container-item d-flex border-grey__bottom">
      <div class="logo col-2 d-flex justify-content-center align-items-center">
        <img *ngIf="headerPathLogo" loading="lazy" width="172" height="60"
        (click)="helpersService.goToHomeLang()" [src]="headerPathLogo" [alt]="headerAltLogo ? headerAltLogo : 'logo header'"
        tabindex="0">
      </div>
      <div id="items-col" class="col-10 d-flex flex-row container-list-second-menu">
        <div *ngIf="header && header.field_main_menu.length;" class="d-flex align-items-center w-100">
          <ul class="nav nav-tabs w-100 h-100 flex-nowrap" id="myTab" role="tablist">
            <!-- VOCI MENU -->
            <ng-container *ngFor="let item of header.field_main_menu; let i = index">
              <ng-container *ngIf="item.enabled">
                <li class="nav-item text-item-second-level d-flex justify-content-center align-items-center" role="presentation"
                  [ngClass]="{'active-label': helpersService.menuHeaderOpenBS.value && ((item.label+'-tab-'+i) === this.helpersService.menuHeaderClickedIdBS.value)}">
                  <div class="nav-link border-none" id="{{ item.label }}-tab-{{ i }}" type="button" role="tab" tabindex="0"
                    data-bs-toggle="tab" [attr.data-bs-target]="'#tab-menu-' + i" (click)="itemClicked(i,item.label+'-tab-'+i)">
                    <!-- voci con subtree -->
                    <div *ngIf="!item.external && item.subtree.length" aria-hidden="true"
                      class="ls-label-large text-brand-10 label-menu d-flex align-items-center">{{item.label}}
                      <i *ngIf="item && item.subtree.length && !((item.label+'-tab-'+i) === helpersService.menuHeaderClickedIdBS.value)"
                        class="fa-solid fa-chevron-down ms-2" (click)="itemClicked(i,item.label+'-tab-'+i, $event)" aria-hidden="true"></i>
                      <i *ngIf="item && item.subtree.length && helpersService.menuHeaderOpenBS.value && ((item.label+'-tab-'+i) === helpersService.menuHeaderClickedIdBS.value)"
                        class="fa-solid fa-chevron-up ms-2" (click)="itemClicked(i,item.label+'-tab-'+i, $event)" aria-hidden="true"></i>
                    </div>
                    <!-- end voci con subtree -->
                    <a class="no-anchor" *ngIf="!item.external && !item.subtree.length" aria-hidden="true"
                      [routerLink]="navigationService.splitUrlRouterLink(item.link).path"
                      [queryParams]="navigationService.splitUrlRouterLink(item.link).queryParams" aria-hidden="true">{{item.label}}</a>
                    <a class="no-anchor" *ngIf="item.external" [href]="item.link" target="_blank"
                      href="JavaScript:void(0);">{{item.label}}</a>
                  </div>
                </li>
              </ng-container>
            </ng-container>
            <!-- END VOCI MENU -->
          </ul>
        </div>
      </div>
    </div>
    <ng-container *ngIf="header && header.field_main_menu.length">
      <div class="tab-content bg-white disable-col" id="myTabContent">
        <ng-container *ngFor="let item of header.field_main_menu; let i = index">
          <div *ngIf="item.enabled" class="tab-pane border-grey__bottom fade" id="{{'tab-menu-' + i}}" role="tabpanel"
            aria-labelledby="{{ item.label }}-tab-{{ i }}"
            [ngClass]="{'fade show active-label': helpersService.menuHeaderOpenBS.value && item.label+'-tab-'+i === helpersService.menuHeaderClickedIdBS.value}">
            <!-- dentro menu -->
            <ng-container *ngIf="item.subtree.length">
              <div class="row gx-0">
                <div class="col-3 py-5 ps-5 pe-4">
                  <div class="d-flex flex-column align-items-between mb-5">
                    <h3 [ngClass]="item.alt_view ? '' : 'text-primary-g'" class="text-garamond fs-32"
                      style="font-weight: 400;" *ngIf="item.label">{{item.label}}</h3>
                    <p class="pt-1 ls-p text-neutral-40" *ngIf="item.text">{{item.text}}</p>
                  </div>
                  <a *ngIf="item.alt_view === false" [routerLink]="navigationService.splitUrlRouterLink(item.link).path" [queryParams]="navigationService.splitUrlRouterLink(item.link).queryParams">
                    <div class="card__card-body__cta" (click)="resetVariableDesktop()">
                      <div
                        class="card__card-body__cta__text d-flex justify-content-between align-items-center pt-5 pb-2">
                        <span class="m-0 text-primary-g ls-label-small-semibold text-uppercase">
                          {{"MENU_SECOND_LEVEL.DISCOVER_THE_SECTION" | translate}}
                        </span>
                        <i class="fa-solid fa-arrow-right text-success fw-bolder" aria-hidden="true"></i>
                      </div>
                      <div class="card__card-body__cta__line"></div>
                    </div>
                  </a>
                </div>
                <ng-container *ngFor="let menuItem of item.menu_custom; let i=index">
                  <div [class.border-grey__left]="i === 0"
                    [ngClass]="item.menu_custom && item.menu_custom.length > 1 ? 'col-3' : 'col-6'"
                    class="my-5 d-flex flex-column">
                    <ng-container *ngFor="let subitem of menuItem">
                      <div *ngIf="subitem.enabled" class="pb-2 ps-5 fs-16" style="font-weight: 600;">
                        <p *ngIf="subitem.link === ''" class="text-uppercase fw-bold fs-12 text-gold">
                          {{subitem.label}}
                        </p>
                        <a class="text-brand-10" *ngIf="subitem.link != '' && !subitem.external" 
                          [routerLink]="navigationService.splitUrlRouterLink(subitem.link).path" 
                          [queryParams]="navigationService.splitUrlRouterLink(subitem.link).queryParams"
                          (click)="resetVariableDesktop()">
                          {{subitem.label}}
                        </a>
                        <a class="text-brand-10" *ngIf="subitem.link != '' && subitem.external" 
                          [href]="subitem.link" (click)="resetVariableDesktop()">
                          {{subitem.label}}
                        </a>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
                <ng-container *ngIf="item.highlight_news">
                  <a *ngIf="item.highlight_news.field_url_immagine"
                    [ngStyle]="{'background-image': 'url(' + item.highlight_news.field_url_immagine + ')'}"
                    class="no-anchor container-news-menu col-3" [routerLink]="navigationService.splitUrlRouterLink(item.highlight_news.field_link_news).path" [queryParams]="navigationService.splitUrlRouterLink(item.highlight_news.field_link_news).queryParams">
                    <div class="container-news-menu__body d-flex flex-column justify-content-between h-100 p-5">
                      <div *ngIf="item.highlight_news.field_created_at" class="container-news-menu__body__badge d-flex">
                        <p class="m-0 text-white py-1 px-3">
                          {{item.highlight_news.field_created_at | localizedDate: "dd MMMM yyyy"}}
                        </p>
                      </div>
                      <div *ngIf="item.highlight_news.field_titolo"
                        class="container-news-menu__body__text text-white pb-4">
                        <p class="m-0 w-75" [innerHTML]="item.highlight_news.field_titolo"></p>
                      </div>
                    </div>
                  </a>
                </ng-container>
              </div>
            </ng-container>
            <!-- end dentro menu -->
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  </ng-container>
  <!--MOBILE MENU-->
  <div class="hidden-web header-mobile">
    <!-- TOP BAR -->
    <div class="row gx-0">
      <div class="col-6">
        <div class="d-flex align-items-center justify-content-center col-12">
          <div class="text-center font-size-12px pe-2">
            <img loading="lazy" src="{{icon}}" alt="image-{{iconAlt}}" style="width: 32px; height: 32px;">
          </div>
          <div class="dropdown-container-selection-user-mobile" ngbDropdown>
            <button class="btn col-9 w-100 button-selection-user d-flex ps-0 pb-0 h-50" ngbDropdownToggle
              (click)="contenutiPerClicked()">
              <div class="w-100 d-flex flex-column text-start">
                <p *ngIf="!isContenutiPerClicked" class="mb-0 fs-12 me-1 ">{{ "HEADER.SELECT_CONTENT_FOR" | translate
                  }}<i class="fa fa-chevron-down ms-2" aria-hidden="true"></i></p>
                <p *ngIf="isContenutiPerClicked" class="mb-0 fs-12 me-1 ">{{ "HEADER.SELECT_CONTENT_FOR" | translate
                  }}<i class="fa fa-chevron-up ms-2" aria-hidden="true"></i></p>
                <div>
                  <span class="font-size-14px text-primary-g" style="font-weight: 700;">
                    {{contenutiPerType.length > 12 ? contenutiPerType.substring(0, 12) + '...' : contenutiPerType}}
                  </span>
                </div>
              </div>
            </button>
            <div *ngIf="header && header.field_barra_terziaria"
              class="dropdown-item-container-selection-user-mobile p-0 border-0 shadow" ngbDropdownMenu>
              <button *ngFor="let item of header.field_barra_terziaria" class="item w-100 text-uppercase"
                ngbDropdownItem>
                <img loading="lazy" class="me-4" style="width: 28px;" src="{{env.urlApi}}{{item.field_icona_elemento_menu}}" alt="icon_menu">
                <span *ngFor="let subItem of item.field_link_correlato" class="ls-label-small-semibold text-brand-10"
                  (click)="changeContenutiPer(item)">
                  {{subItem.label}}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 d-flex justify-content-end">
        <div
          class="col-8 col-sm-9 col-md-10 d-flex justify-content-start bg-secondary-g text-primary-g align-items-center text-center login-language-container-mobile"
          ngbDropdown>
          <button type="button" id="dropdownBasic2" class="mx-4 align-items-center h-100 pe-4 text-brand-40"
            ngbDropdownToggle style="border-right: 1px solid #CCD1CF;" (click)="loginTypeClicked()">
            <span *ngIf="!isLoginTypeClicked" class="font-size-12px text-uppercase"><strong>{{loginType | translate}} <i
                  class="fa fa-chevron-down ms-2" aria-hidden="true"></i></strong></span>
            <span *ngIf="isLoginTypeClicked" class="font-size-12px text-uppercase"><strong>{{loginType | translate}} <i
                  class="fa fa-chevron-up ms-2" aria-hidden="true"></i></strong></span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic2"
            class="dropdown-item-container-mobile p-0 border-0 shadow-sm">
            <button ngbDropdownItem class="item me-1" (click)="changeLogin('mialumsa')"><img loading="lazy"
                src="./assets/images/alternate_email.png" class="me-1" alt="LUMSA">MI@LUMSA</button>
            <button ngbDropdownItem class="item me-1" (click)="changeLogin('lumsa')"><img loading="lazy"
                src="./assets/images/language-grey.png" class="me-1" alt="LUMSA">LUMSA.IT</button>
            <button ngbDropdownItem class="item me-1" (click)="changeLogin('intranet')"><img loading="lazy"
                src="./assets/images/lan.png" class="me-1" alt="LUMSA">INTRANET</button>
          </div>
        </div>
        <div ngbDropdown class="col-4 col-sm-3 col-md-2 dropdown-container dropdownLanguageMobile bg-secondary-g align-self-center">
          <button type="button" id="dropdownLanguageMobile" class="btn text-primary-g font-size-12px h-50px ps-0" [attr.aria-label]="'dropdownLanguage'"
            ngbDropdownToggle>
            <span *ngIf="currentLang && imageLanguages">
              <!-- <img src="{{imageLanguages.url}}" class="me-1 widAndHei-24" alt="LUMSA"> -->
              <span>{{imageLanguages.text}}</span>
              <i class="fa fa-chevron-down ms-2 mt-2" aria-hidden="true"></i>
            </span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownLanguageMobile" class="dropdown-item-container p-0 border-0 shadow">

            <button ngbDropdownItem class="item me-1 d-flex justify-content-center align-items-center">
              <!-- <img loading="lazy" src="{{imageLanguages.url}}" alt="icon_language_{{imageLanguages.codeApi}} | Lumsa" class="me-1 widAndHei-24"> -->
              {{imageLanguages.text}}
              <i class="fa fa-chevron-up ms-2" aria-hidden="true"></i>
            </button>
            <ng-container *ngFor="let lang of languagesList; index as i">
              <button *ngIf="lang.text != imageLanguages.text && (!lang.showOnlyInNodeType || lang.showOnlyInNodeType === helpersService.nodeType)" ngbDropdownItem (click)="changeLang(lang.code)" class="item me-1 d-flex justify-content-center align-items-center">
                <!-- <img loading="lazy" src="{{lang.url}}" alt="icon_language_{{lang.codeApi}} | Lumsa" class="me-1 widAndHei-24"> -->
                {{lang.text}}
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- SEARCH BAR MOBILE -->

    <div *ngIf="showSearchBar" class="hidden-web col-12 d-flex flex-column search-container-mobile">
      <div class="col-12 h-80px">
        <form class="form-inline w-100">
          <div class="d-flex shadow h-50px">
            <input [formControl]="searchGlobal" [ngModelOptions]="{standalone: true}" type="search"
              placeholder="{{ 'HEADER.WHAT_LOOKING' | translate }}" aria-label="Search" tabindex="1"
              class="w-100 border-0 p-3">
          </div>
        </form>
      </div>
      <div class="col-12 w-100 d-flex search-mobile-dropdown-container border-grey__top shadow">
        <div ngbDropdown class="col-10">
          <button type="button"
            class="border-0 h-50px text-uppercase ls-label-small-semibold text-brand-10 w-100 bg-white d-flex justify-content-between align-items-center px-3"
            ngbDropdownToggle id="dropdownContentMobile">
            <span>{{ typeSearch | translate }}</span>
            <i class="fa fa-chevron-down ms-1 arrow" aria-hidden="true"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownContentMobile" class="w-100 py-0">
            <button ngbDropdownItem class="item me-1 p-3 border-bottom ls-label-small-semibold text-brand-10 text-uppercase"
              (click)="changeTypeSearch('search')">
              <img loading="lazy" src="./assets/images/language.png" alt="icon_search_all | Lumsa" class="me-1">
              {{ 'HEADER.DROPDOWN_SEARCH.ALL' | translate }}
            </button>
            <button ngbDropdownItem class="item me-1 p-3 border-bottom ls-label-small-semibold text-brand-10 text-uppercase"
              (click)="changeTypeSearch('faqs')">
              <img loading="lazy" src="./assets/images/help.png" alt="icon_search_faq | Lumsa" class="me-1">
              {{ 'HEADER.DROPDOWN_SEARCH.FAQ' | translate }}
            </button>
      </div>
        </div>
        <div (click)="searchWithFilter()" class="col-2 px-4 py-2 d-flex justify-content-center cursor-pointer search-container-second text-center">
          <img loading="lazy" src="./assets/images/search_white.svg" alt="icon search light">
        </div>
      </div>
      <!-- result -->
      <div *ngIf="suggestions && suggestions.length" class="input-search-global__container-suggestions">
        <ul>
          <li *ngFor="let suggestion of suggestions">
            <a [routerLink]="navigationService.splitUrlRouterLink(suggestion.link).path" [queryParams]="navigationService.splitUrlRouterLink(suggestion.link).queryParams" [innerHTML]="suggestion.title" (click)="closeSearchBar('')"></a>
          </li>
        </ul>
      </div>
    </div>

    <!-- END SEARCH BAR MOBILE -->


    <!-- END TOP BAR -->
    <!-- NAVBAR -->
    <div class="container-navbar w-100 px-3 d-flex justify-content-between align-items-center border-grey__bottom">
      <div class="logo col-6" (click)="resetVariableMobile()" [attr.renderssrforclswidth]="172">
        <img loading="lazy" (click)="helpersService.goToHomeLang()" width="172" height="60" [src]="headerPathLogo" [alt]="headerAltLogo ? headerAltLogo : 'header logo'">
      </div>
      <div class="d-flex offset-3 col-3">
        <div class="d-flex justify-content-center cursor-pointer col-6" (click)="showSearchB()">
          <img loading="lazy" src="./assets/images/search_dark.svg" alt="search" height="40" width="40">
        </div>
        <div class="d-flex justify-content-center cursor-pointer col-6" (click)="openMenu()">
          <img loading="lazy" *ngIf="!isOpenMenu && !isOpenItemMenu" src="./assets/images/icon_menu_mobile.svg" alt="icon open menu" height="40" width="40">
          <img loading="lazy" *ngIf="isOpenMenu || isOpenItemMenu" src="./assets/images/icon_close_menu_mobile.svg" height="40" width="40"
            alt="icon close menu">
        </div>
      </div>
    </div>
    <!-- END NAVBAR -->
    <!-- CONTENT MENU -->
    <div [@menuMobileTrigger] *ngIf="isOpenMenu" class="container-item-menu">
      <div class="container-item-menu__item-body h-50 p-0 m-0">
        <ul class="flex-wrap gx-0 d-flex flex-row me-auto mb-lg-0 p-0 border-grey__bottom h-100">
          <ng-container *ngFor="let item of header.field_main_menu; let i = index">
            <li *ngIf="item.enabled" [class.border-grey__right]="i % 2 === 0"
              [class.border-grey__bottom]="i < header.field_main_menu.length - 1"
              class="col-6 no-anchor height-px h-25 d-flex align-items-center cursor-pointer" (click)="openItemMenu(i)">
              <a class="no-anchor ls-label-large text-brand-10">{{item.label}}</a>
            </li>
          </ng-container>
        </ul>
      </div>
      <div class="container-item-menu__item-footer h-50 d-flex flex-column">
        <div *ngIf="header && header.field_barra_secondaria" class="container-item-menu__item-footer__container-list">
          <ngb-accordion #acc="ngbAccordion" [animation]="true"
            class="container-item-menu__item-footer__container-list__accordion">
            <ng-container *ngFor="let itemMenuSec of menuSecMobile; let i = index">
              <ngb-panel>
                <ng-template ngbPanelTitle>
                  <div class="d-flex justify-content-between align-items-center text-brand-40 w-100">
                    <p class="ls-label-small-semibold text-brand-40 text-uppercase mb-0" [innerHTML]="itemMenuSec.titleAccordion"></p>
                    <div class="pe-2 d-flex align-items-center">
                      <i class="fa-sharp fa-solid fa-caret-down"></i>
                    </div>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <ng-container *ngFor="let contentAcc of itemMenuSec.contentAccordion">
                    <p *ngIf="contentAcc.titleItem" class="title-menu-mob mb-0 pt-0 pb-2 ls-label-medium text-uppercase" [innerHTML]="contentAcc.titleItem"></p>
                    <div *ngIf="contentAcc.contentItem.length">
                      <ul>
                        <li *ngFor="let item of contentAcc.contentItem">
                          <div *ngIf="item.value" class="ls-label-medium text-brand-10 description-container" [innerHTML]="item.value"></div>
                          <!-- <div *ngFor="let link of contentAcc.linkItem">
                            <a class="item-link ls-label-medium-semibold mb-3" [href]="link.url" [innerHTML]="link.label"></a>                            
                          </div> -->
                        </li>
                      </ul>
                    </div>
                    
                    <div *ngFor="let subItem of contentAcc.linkItem; let i=index" [class.contentItem2Menu]="contentAcc.contentItem.length" [class.pb-2]="i == contentAcc.linkItem.length -1">
                      <a *ngIf="!(subItem.url.startsWith('http'))" class="item-link ls-label-medium-semibold mb-3" 
                        [routerLink]="navigationService.splitUrlRouterLink(subItem.url).path" (click)="openMenu()"
                        [queryParams]="navigationService.splitUrlRouterLink(subItem.url).queryParams">
                        {{subItem.label}}
                      </a>
                      <a *ngIf="subItem.url.startsWith('http')" [href]="subItem.url" target="_blank" class="item-link ls-label-medium-semibold mb-3">{{subItem.label}}</a>
                    </div>
                  </ng-container>
                </ng-template>
              </ngb-panel>
            </ng-container>
          </ngb-accordion>
        </div>
        <div class="col-12 d-flex justify-content-start align-items-end list-style-none mb-0 w-100 pt-3 pb-4">
          <div *ngFor="let social of nodeService.header.field_link_social" class="mb-0 me-2">
            <div *ngFor="let item of social.field_nome_social" class="">
              <a *ngFor="let linkSocial of social.field_link_social" class="" aria-label="icon_social_{{item.value.toLowerCase()}}" [href]="linkSocial.value" target="_blank">
                <img loading="lazy" [src]="nodeService.hashMapSocialPngGreen[item.value]" alt="icon_social_{{item.value.toLowerCase()}}"  class="widAndHei-32">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END CONTENT MENU -->
    <!-- SUBTREE MOBILE -->
    <div *ngIf="isOpenItemMenu && !isOpenMenu" class="container-body-item scroll-y">
      <div class="container-body-item__body h-25 p-4">
        <div class="d-flex align-items-center">
          <img loading="lazy" src="./assets/images/menu-mobile/menu_mobile_arrow_back.svg" alt="icon back | LUMSA" (click)="returnToMenu()">
          <h3 class="text-garamond ls-h2-section-title text-brand-10" [innerHTML]="contentMenu.label"></h3>
        </div>
        <a *ngIf="!contentMenu.alt_view && !contentMenu.external" [routerLink]="navigationService.splitUrlRouterLink(contentMenu.link).path" [queryParams]="navigationService.splitUrlRouterLink(contentMenu.link).queryParams">
          <div class="d-flex flex-column justify-content-between cursor-pointer"
            (click)="resetVariableMobile()">
            <p class="ls-label-medium-semibold text-brand-40 text-uppercase">{{"MENU_SECOND_LEVEL.DISCOVER_THE_SECTION" | translate}}</p>
          </div>
        </a>
        <a *ngIf="!contentMenu.alt_view && contentMenu.external" [href]="contentMenu.link">
          <div class="d-flex flex-column justify-content-between cursor-pointer"
            (click)="resetVariableMobile()">
            <p class="ls-label-medium-semibold text-brand-40 text-uppercase">{{"MENU_SECOND_LEVEL.DISCOVER_THE_SECTION" | translate}}</p>
          </div>
        </a>
      </div>
      <div class="container-body-item__list d-flex flex-column justify-content-between">
        <ul class="h-100 m-0">
          <ng-container *ngFor="let item of contentMenu.subtree; let idx = index;">
            <li *ngIf="item.enabled" class="pe-4 cursor-pointer"
              (click)="resetVariableMobile()">
              <a *ngIf="!item.external" [routerLink]="navigationService.splitUrlRouterLink(item.link).path" [queryParams]="navigationService.splitUrlRouterLink(item.link).queryParams">
                <p *ngIf="item.link === ''" class="m-0 pt-5 text-uppercase ls-label-small-semibold text-support-40" [innerHTML]="item.label"></p>
                <p *ngIf="item.link != ''" [class.border-grey__bottom]="idx < contentMenu.subtree.length - 1" class="m-0 ls-label-large-semibold text-brand-10 py-4" [innerHTML]="item.label"></p>
              </a>
              <a *ngIf="item.external" [href]="item.link">
                <p *ngIf="item.link === ''" class="m-0 pt-5 text-uppercase ls-label-small-semibold text-support-40" [innerHTML]="item.label"></p>
                <p *ngIf="item.link != ''" [class.border-grey__bottom]="idx < contentMenu.subtree.length - 1" class="m-0 ls-label-large-semibold text-brand-10 py-4" [innerHTML]="item.label"></p>
              </a>
            </li>
          </ng-container>
        </ul>
        <div class="col-12 d-flex justify-content-start align-items-end list-style-none mb-0 w-100 p-4">
          <div *ngFor="let social of nodeService.header.field_link_social" class="mb-0 me-2">
            <div *ngFor="let item of social.field_nome_social" class="">
              <a *ngFor="let linkSocial of social.field_link_social" class="" aria-label="icon_social_{{item.value.toLowerCase()}}" [href]="linkSocial.value" target="_blank">
                <img loading="lazy" class="widAndHei-32" [src]="nodeService.hashMapSocialPngGreen[item.value]" alt="icon_social_{{item.value.toLowerCase()}}">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END SUBTREE MOBILE -->
  </div>
</div>